import { useTranslation } from 'react-i18next';
import { DeleteOutlined, FilterOutlined } from "@ant-design/icons";
import { Button, Flex, Form, Typography } from "antd";
import { useForm } from "antd/es/form/Form";
import { FormInstance } from "antd/lib";
import { FunctionComponent } from "react";
import SelectUiCard from "../../../../../components/select-ui";
import "./filter-group.scss";

type FormFilterProps = {
  showFilter?: boolean;
  clearFilter: (form: FormInstance) => void;
  onFinish?: any;
  optionSelectTag: any;
  setDataFilter: any;
  setKeySearch: any;
};

const FormFilter: FunctionComponent<FormFilterProps> = ({
  showFilter,
  clearFilter,
  onFinish,
  optionSelectTag,
  setDataFilter,
  setKeySearch,
}) => {
  const { t } = useTranslation();
  const [form] = useForm();
  const onChangeShareReport = (val: string, name: string) => {
    setDataFilter(val);
  };

  const handleSearch = (value: string) => {
    setKeySearch(value)
  };
  return (
    <>
      <div className={`wrapper-filter ${showFilter ? "open" : ""} !pl-0`}>
        <Form
          name="formFilterMinistries"
          onFinish={onFinish}
          form={form}
          className="flex-wrap flex"
        >
          <Flex justify="end" className="w-full lg:w-4/5 pr-3">
            <SelectUiCard
              className="font-medium w-full lg:w-1/3"
              name="tags"
              label=""
              filterOption={(input: any, option: any) =>
                option?.title?.toLowerCase().includes(input.toLowerCase())
              }
              options={optionSelectTag}
              mode="multiple"
              placeholder={t("Chọn thẻ tag", "Chọn thẻ tag")}
              handleSearch={handleSearch}
              allowClear
              onChange={(val) => onChangeShareReport(val, "tags")}
            />
          </Flex>

          <Flex className="w-full lg:w-1/5">
            <Button
              className="btn btn-primary filter-btn mr-2 lg:mr-0"
              htmlType="submit"
            >
              <FilterOutlined />
              <Typography.Text>{t("Lọc", "Lọc")}</Typography.Text>
            </Button>
            <Button
              className="btn btn-outlined clear-filter-btn"
              onClick={() => clearFilter(form)}
            >
              <DeleteOutlined />
              <Typography.Text>{t("Xóa bộ lọc", "Xóa bộ lọc")}</Typography.Text>
            </Button>
          </Flex>
        </Form>
      </div>
    </>
  );
};

export default FormFilter;
